import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

// Simple Modal Component (you can customize or replace with a library)
const Modal = ({ message, onConfirm }) => (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
    }}
  >
    <div
      style={{
        background: "white",
        padding: "20px",
        borderRadius: "8px",
        textAlign: "center",
        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
      }}
    >
      <p>{message}</p>
      <button
        onClick={onConfirm}
        style={{ padding: "10px 20px", cursor: "pointer" }}
      >
        Okay
      </button>
    </div>
  </div>
);

const IdleTimeout = ({ children, timeout = 3600000 }) => {
  // Default to 1 hour in ms
  const [isIdle, setIsIdle] = useState(false);
  const navigate = useNavigate();
  const timeoutRef = useRef(null);
  const events = [
    "mousemove",
    "keydown",
    "wheel",
    "DOMMouseScroll",
    "mousewheel",
    "mousedown",
    "touchstart",
    "touchmove",
    "MSPointerDown",
    "MSPointerMove",
    "visibilitychange",
  ];

  const resetTimer = () => {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => setIsIdle(true), timeout);
  };

  const handleConfirm = () => {
    setIsIdle(false);
    // Redirect to root (login page) - works for both localhost and production
    navigate("/");
    // Or use window.location.href = window.location.origin; if no React Router
  };

  useEffect(() => {
    // Add event listeners on mount
    events.forEach((event) =>
      document.addEventListener(event, resetTimer, true)
    );
    resetTimer(); // Start initial timer

    return () => {
      // Cleanup on unmount
      events.forEach((event) =>
        document.removeEventListener(event, resetTimer, true)
      );
      clearTimeout(timeoutRef.current);
    };
  }, []);

  return (
    <>
      {children}
      {isIdle && (
        <Modal
          message="Session expired, please login again."
          onConfirm={handleConfirm}
        />
      )}
    </>
  );
};

export default IdleTimeout;
